export const tagClasses = 'px-2 px-lg-3 py-2 m-2';
export const tagClassesThumbnail = 'm-lg-3';
